const showHeader = () => {
  const header = document.querySelector('header');

  if (!header.classList.contains('loaded')) {
    header.classList.add('loaded');
  }
};

export default showHeader;
